import { SelectedMenu } from 'rangeConfig/@types';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeHandle',
  behaviors: {
    productDeleted: []
  },
  content: []
};

export default selectedMenu;
